import React from "react";
import ReactPaginate from "react-paginate";
import MyDiv from "./customPagination.style";
import { Image, Select, Flex, Text } from "@chakra-ui/react";
import RightArrowIcon from "../../assets/images/arrow-right.svg";
import LeftArrowIcon from "../../assets/images/arrow-left.svg";

// interface CustomPaginationProps {
//   pageCount: number;
//   handlePageClick: (selectedItem: { selected: number }) => void;
//   rowsPerPage?: number;
//   setRowsPerPage?: (value: number) => void;
//   currentPage?: number;
//   totalRecords?: number;
// }

interface CustomPaginationProps {
  pageCount: number;
  handlePageClick: (selectedItem: { selected: number }) => void;
  rowsPerPage?: number;
  setRowsPerPage?: (value: number) => void;
  currentPage?: number;
  totalRecords?: number;
  rowsPerPageOptions?: number[];
}


export default function CustomPagination({
  pageCount,
  handlePageClick,
  rowsPerPage,
  setRowsPerPage,
  currentPage = 0,
  totalRecords = 0,
  rowsPerPageOptions
}: CustomPaginationProps) {
  const start = totalRecords === 0 ? 0 : currentPage * (rowsPerPage || 1) + 1;
  const end = Math.min((currentPage + 1) * (rowsPerPage || 1), totalRecords);


  return (
    <MyDiv>
      <Flex justify="center" align="center" mt={4} gap={4}>
        <ReactPaginate
          previousLabel={
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Image src={LeftArrowIcon} alt="Prev" width={15} height={15} />
              Prev
            </span>
          }
          nextLabel={
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              Next
              <Image src={RightArrowIcon} alt="Next" width={15} height={15} />
            </span>
          }
          pageCount={pageCount}
          onPageChange={handlePageClick}
          forcePage={currentPage}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />

        {/* {rowsPerPage !== undefined && setRowsPerPage && (
          <Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            width="70px"
            size="sm"
          >
            <option value={9}>9</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </Select>
        )} */}

        {rowsPerPage !== undefined && setRowsPerPage && (
          <Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            width="70px"
            size="sm"
          >
            {(rowsPerPageOptions || [9, 50, 100, 200]).map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Select>
        )}


        <Text fontSize="sm" fontWeight="500">
          {totalRecords > 0 ? `Showing ${start}-${end} of ${totalRecords} records` : 'No records found'}
        </Text>

      </Flex>
    </MyDiv>
  );
}
